import { List } from 'immutable';
import { leadFilterGroupConstants } from '../constants';

export function lead_filter_groups(state = {}, action) {
  switch (action.type) {
    case leadFilterGroupConstants.LEAD_FILTER_GROUP_LIST_LOADING:
      return {
        ...state,
        items: null,
        listLoading: true
      };
    case leadFilterGroupConstants.LEAD_FILTER_GROUP_LIST_SUCCESS:
      return {
        ...state,
        items: List(action.response),
        listLoading: false
      };
    case leadFilterGroupConstants.LEAD_FILTER_GROUP_LIST_FAILURE:
      return {
        ...state,
        listLoading: false,
        items: null,
        listError: action.error
      };
    case leadFilterGroupConstants.LEAD_FILTER_GROUP_CREATE_LOADING:
      return {
        ...state,
        createLoading: true
      };
    case leadFilterGroupConstants.LEAD_FILTER_GROUP_CREATE_SUCCESS: {
      const items = state.items ? state.items : List();
      return {
        ...state,
        items: items.push(action.response),
        createLoading: false,
        createError: null
      };
    }
    case leadFilterGroupConstants.LEAD_FILTER_GROUP_CREATE_FAILURE:
      return {
        ...state,
        createLoading: false,
        createError: action.error
      };

    case leadFilterGroupConstants.LEAD_FILTER_GROUP_EDIT_LOADING:
      return {
        ...state,
        editLoading: true
      };
    case leadFilterGroupConstants.LEAD_FILTER_GROUP_EDIT_SUCCESS: {
      if (!state.items) {
        return state;
      }

      const leadFilterGroupIndex = state.items.findIndex(val => val.id == action.response.id);

      if (leadFilterGroupIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.set(leadFilterGroupIndex, action.response),
        editLoading: false,
        editError: null
      };
    }
    case leadFilterGroupConstants.LEAD_FILTER_GROUP_EDIT_FAILURE:
      return {
        ...state,
        editLoading: false,
        editError: action.error
      };

    case leadFilterGroupConstants.LEAD_FILTER_GROUP_DELETE_LOADING:
      return {
        ...state,
        deleteLoading: true
      };
    case leadFilterGroupConstants.LEAD_FILTER_GROUP_DELETE_SUCCESS: {
      const { leadFilterGroupId } = action;

      if (!state.items) {
        return state;
      }

      const leadFilterIndex = state.items.findIndex(val => val.id == leadFilterGroupId);

      if (leadFilterIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.delete(leadFilterIndex),
        deleteLoading: false,
        deleteError: null
      };
    }
    case leadFilterGroupConstants.LEAD_FILTER_GROUP_DELETE_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        deleteError: action.error
      };
    case leadFilterGroupConstants.LEAD_FILTER_GROUP_ERROR_RELOAD:
      return {
        ...state,
        createError: null,
        editError: null
      };

    default:
      return state;
  }
}
